import {Efeito, IEffectsTable, DataFieldProps} from "../../types";
import {DataField} from "../dataField";
import {
  TableContainer, Card, CardList,
  CardTitle, CardTable, CardParagraph, CardTableHeaderCell, CardTableHead, CardTableCell
} from "../../styles";
import {Modal, Table} from "antd";
import {TableColumn} from "../../../../../components/Table";
import {formatDateView, formatDocument, formatMoney} from "../../../../adiqEdi/detalhesEdi/utils";
import React, {useEffect, useState} from "react";
import LoadingOverlay from "../../../../../components/LoadingOverlay";
import EfeitoDeContratoService from "../../service/efeitoDeContratoService";
import {formatAgency, formatDivisionRule} from "../../utils";
import {EyeOutlined} from "@ant-design/icons";
import {formatEffectType} from "../../utils";
import useGetMe from "../../../../../hooks/useCurrentUser";


export const LiveTable: React.FC<IEffectsTable> = ({
                                                     dataFilter,
                                                     pageSize,
                                                     currentPage,
                                                     onPageChange,
                                                     onPageSizeChange,
                                                   }) => {

  const [efeitos, setEfeitos] = useState<any[]>([]);
  const user = useGetMe();
  const formattedDate = (date: string) => formatDateView(date);
  const formattedEffect = (effectType: string) => formatEffectType(effectType);
  const formmattedDivision = (divisionRules: string) => formatDivisionRule(divisionRules);
  const formattedMoney = (value: number) => formatMoney(value);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const efeitoDeContratoService = new EfeitoDeContratoService();
  const formattedDocument = (document: string) => formatDocument(document);
  const [modalOpen, setModalOpen] = useState(false);
  const [transactionData, setTransactionData] = useState(null);

  const handleCloseModal = () => {
    setModalOpen(false);
    setTransactionData(null);
  }

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const filtros = {
          settlementDate: dataFilter.settlementDate || '',
          cnpj: dataFilter.cnpj || '',
          status: dataFilter.status || '',
          ispb: dataFilter.ispb || '',
        };

        const response = await efeitoDeContratoService.getEffects(filtros);
        setEfeitos(response.items?.$values);
      } catch (error) {
        console.error("Erro:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [dataFilter]);

  return (
    <div>
      <LoadingOverlay
        show={isLoading}
        relative
      />
      <TableContainer>
        <Table
          dataSource={Array.isArray(efeitos) ? efeitos : []}
          rowKey="id"
          pagination={{
            defaultPageSize: pageSize,
            defaultCurrent: currentPage,
            current: currentPage,
            onShowSizeChange: (_, size) => {
              onPageSizeChange(size);
            },
            onChange: (pageNum) => onPageChange(pageNum),
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} de ${total} efeitos`,
          }}
        >
          <TableColumn title="Data Liquidação" dataIndex="settlementDate" key="settlementDate" render={formattedDate}/>
          <TableColumn title="CPF/CNPJ Cliente" dataIndex="finalReceiverUser" key="finalReceiverUser"
                       render={formattedDocument}/>
          <TableColumn title="Código Unidade Recebível" dataIndex="externalReferenceUR" key="externalReferenceUR"/>
          <TableColumn
            title="Valor Comprometido"
            key="committedValue"
            render={(_, record: any) => {
              const value = record.contractEffects?.$values?.[0]?.committedValue;
              return value != null ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : '-';
            }}
          />
          <TableColumn title="Arranjo Afetado" dataIndex="paymentArrangement" key="paymentArrangement"/>
          <TableColumn
            title="Valor Constituido Total"
            dataIndex="totalConstitutedValue"
            key="totalConstitutedValue"
            render={formattedMoney}
          />
          <TableColumn
            title="CNPJ Beneficiario"
            dataIndex="beneficiaryHolder"
            key="beneficiaryHolder"
            render={(_, record: any) => {
              const doc = record.contractEffects?.$values?.[0]?.beneficiaryHolder;
              return formattedDocument(doc)}}
          />
          <TableColumn
            title="Agência"
            key="branch"
            render={(_, record: any) => record.contractEffects?.$values?.[0]?.branch || '-'}
          />
          <TableColumn
            title="ISPB"
            key="ispb"
            render={(_, record: any) => record.contractEffects?.$values?.[0]?.ispb || '-'}
          />
          <TableColumn
            title="Conta"
            key="accountNumber"
            render={(_, record: any) => record.contractEffects?.$values?.[0]?.accountNumber || '-'}
          />
          <TableColumn
            title="Tipo Conta"
            key="accountType"
            render={(_, record: any) => record.contractEffects?.$values?.[0]?.accountType || '-'}
          />
          <TableColumn
            title="Id do Contrato"
            key="contractIdentifier"
            render={(_, record: any) => record.contractEffects?.$values?.[0]?.contractIdentifier || '-'}
          />
          <TableColumn
            title="Status"
            key="status"
            render={(_, record: any) => record.contractEffects?.$values?.[0]?.status || '-'}
          />
          {user.userType === 3 && (
            <TableColumn
              title="Detalhes"
              key="details"
              render={(_, efeitos: any) => (
                <EyeOutlined style={{
                  fontSize: "20px",
                  display: 'flex',
                  justifyContent: 'center'
                }} onClick={() => {
                  const contractEffect = efeitos?.contractEffects?.$values?.[0] || {};
                  setTransactionData({
                    ...efeitos,
                    contractEffectIndicator: contractEffect.contractEffectIndicator,
                    protocol: contractEffect.protocol,
                    effectType: contractEffect.effectType,
                    divisionRules: contractEffect.divisionRules,
                  });
                  setModalOpen(true);
                }}
                />
              )}
            />
          )
          }
        </Table>
      </TableContainer>
      <Modal
        title="Detalhes da Unidade de Recebível"
        open={modalOpen}
        onCancel={handleCloseModal}
        footer={null}
        width={800}
      >
        <Card>
          <CardTitle> Unidade de Recebível (UR)</CardTitle>
          <DataField
            dataIndex="externalReferenceUR"
            key="externalReferenceUR"
            record={transactionData}
            label="Código Unidade Recebível"
          />
          <DataField
            dataIndex="systemRegistrationTimestamp"
            key="systemRegistrationTimestamp"
            record={transactionData}
            label="Data de Registro no Sistema"
            render={formattedDate}
          />
          <DataField
            dataIndex="sourceFileName"
            key="sourceFileName"
            record={transactionData}
            label="Caminho do Arquivo"
          />
          <DataField
            dataIndex="protocol"
            key="protocol"
            record={transactionData}
            label="Protocolo do Efeito"
          />
          <CardParagraph><strong>Detalhes Contrato:</strong></CardParagraph>
          <CardList>
            <DataField
              dataIndex="contractEffectIndicator"
              key="contractEffectIndicator"
              record={transactionData}
              label="Indicador de Efeitos de Contratos"
            />
            <DataField
              dataIndex="effectType"
              key="effectType"
              record={transactionData}
              label="Tipo de Efeito"
              render={formattedEffect}
            />
            <DataField
              dataIndex="divisionRules"
              key="divisionRules"
              record={transactionData}
              label="Regra de Divisão"
              render={formmattedDivision}
            />
          </CardList>
        </Card>
      </Modal>
    </div>
  )
};

export default LiveTable;
